import { mergeSx } from "@/utils";

import { SvgIcon } from "@/components/SvgIcon";
import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

export function RollupZkevmFilled({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("RollupZkevmFilled");
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 33 32"
      testId={testId}
      sx={mergeSx({ w: "200px" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

RollupZkevmFilled.displayName = "RollupZkevmFilled";
